import React, { useState } from "react";

/* =========================================================
   MOCK DATA
========================================================= */
const INITIAL_RESULTS = [
  { id: 1, name: "Aarav Sharma", class: "10-A", roll: "101", subject: "Mathematics", marksObtained: 92, totalMarks: 100, grade: "A+" },
  { id: 2, name: "Priya Patel", class: "10-A", roll: "102", subject: "Science", marksObtained: 88, totalMarks: 100, grade: "A" },
  { id: 3, name: "Rohan Gupta", class: "10-A", roll: "103", subject: "English", marksObtained: 65, totalMarks: 100, grade: "B" },
  { id: 4, name: "Ananya Singh", class: "10-B", roll: "104", subject: "Mathematics", marksObtained: 95, totalMarks: 100, grade: "A+" },
  { id: 5, name: "Kabir Verma", class: "10-B", roll: "105", subject: "Science", marksObtained: 72, totalMarks: 100, grade: "B+" },
  { id: 6, name: "Ishita Reddy", class: "10-A", roll: "106", subject: "English", marksObtained: 81, totalMarks: 100, grade: "A" },
  { id: 7, name: "Arjun Nair", class: "10-C", roll: "107", subject: "Mathematics", marksObtained: 45, totalMarks: 100, grade: "D" },
  { id: 8, name: "Sneha Joshi", class: "10-C", roll: "108", subject: "Science", marksObtained: 90, totalMarks: 100, grade: "A+" },
];

const Results = () => {
  const [resultsData] = useState(INITIAL_RESULTS);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterClass, setFilterClass] = useState("All");
  const [filterSubject, setFilterSubject] = useState("All");

  // Filter Logic
  const filteredData = resultsData.filter((student) => {
    const matchesSearch = student.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
                          student.roll.includes(searchTerm);
    const matchesClass = filterClass === "All" || student.class === filterClass;
    const matchesSubject = filterSubject === "All" || student.subject === filterSubject;
    return matchesSearch && matchesClass && matchesSubject;
  });

  // Calculate Stats (Based on filtered data for dynamic feel, or you can base it on all data)
  const totalRecords = resultsData.length;
  const averageMarks = Math.round(
    resultsData.reduce((acc, curr) => acc + curr.marksObtained, 0) / totalRecords
  );
  const highestMarks = Math.max(...resultsData.map((s) => s.marksObtained));
  const passCount = resultsData.filter((s) => s.marksObtained >= 40).length;
  const passPercentage = Math.round((passCount / totalRecords) * 100);

  // Helper to get grade color
  const getGradeColor = (grade) => {
    if (grade.includes("A")) return "grade-a";
    if (grade.includes("B")) return "grade-b";
    if (grade.includes("C")) return "grade-c";
    return "grade-d";
  };

  return (
    <>
      {/* 
        =========================================================
        INLINE STYLES 
        =========================================================
      */}
      <style>{`
        @import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css");
        @import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap");

        .results-page {
          font-family: "Plus Jakarta Sans", sans-serif;
          background-color: #f8fafc;
          min-height: 100vh;
          padding: 40px 20px;
          color: #0f172a;
        }

        .results-container {
          max-width: 1100px;
          margin: 0 auto;
        }

        /* ---------- HEADER ---------- */
        .results-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          margin-bottom: 30px;
          flex-wrap: wrap;
          gap: 20px;
        }

        .results-header h1 {
          font-size: 28px;
          font-weight: 700;
          margin: 0 0 6px 0;
          color: #0f172a;
        }

        .results-header p {
          margin: 0;
          color: #64748b;
          font-size: 15px;
        }

        .header-actions {
          display: flex;
          gap: 12px;
          align-items: center;
        }

        .btn-primary {
          background: #18181b;
          color: #fff;
          border: none;
          padding: 10px 24px;
          border-radius: 12px;
          font-family: inherit;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.2s ease;
          box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .btn-primary:hover {
          background: #27272a;
          transform: translateY(-1px);
          box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
        }

        /* ---------- STATS CARDS ---------- */
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 20px;
          margin-bottom: 30px;
        }

        .stat-card {
          background: #ffffff;
          padding: 20px;
          border-radius: 16px;
          border: 1px solid #e2e8f0;
          display: flex;
          align-items: center;
          gap: 16px;
          box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .stat-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
        }

        .stat-icon {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
        }

        .stat-card.total .stat-icon { background: #e0e7ff; color: #4338ca; }
        .stat-card.average .stat-icon { background: #e0f2fe; color: #0369a1; }
        .stat-card.highest .stat-icon { background: #fef9c3; color: #854d0e; }
        .stat-card.pass .stat-icon { background: #dcfce7; color: #166534; }

        .stat-info {
          display: flex;
          flex-direction: column;
        }

        .stat-info span {
          font-size: 13px;
          color: #64748b;
          font-weight: 500;
          margin-bottom: 4px;
        }

        .stat-info strong {
          font-size: 24px;
          font-weight: 700;
          color: #0f172a;
          line-height: 1;
        }

        /* ---------- TABLE CONTROLS ---------- */
        .table-controls {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
          gap: 16px;
          flex-wrap: wrap;
        }

        .search-box {
          display: flex;
          align-items: center;
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          padding: 0 16px;
          flex: 1;
          max-width: 350px;
          transition: border-color 0.2s;
        }

        .search-box:focus-within {
          border-color: #18181b;
        }

        .search-box .fa {
          color: #64748b;
          font-size: 14px;
        }

        .search-box input {
          border: none;
          background: transparent;
          padding: 12px 10px;
          width: 100%;
          font-family: inherit;
          font-size: 14px;
          color: #0f172a;
          outline: none;
        }

        .filters-group {
          display: flex;
          gap: 12px;
          align-items: center;
          flex-wrap: wrap;
        }

        .filter-box {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          color: #64748b;
        }

        .filter-box select {
          padding: 10px 14px;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          font-family: inherit;
          font-size: 14px;
          color: #0f172a;
          background: #ffffff;
          outline: none;
          cursor: pointer;
        }

        /* ---------- DATA TABLE ---------- */
        .table-responsive {
          background: #ffffff;
          border-radius: 16px;
          border: 1px solid #e2e8f0;
          overflow-x: auto;
          box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
        }

        .results-table {
          width: 100%;
          border-collapse: collapse;
          text-align: left;
        }

        .results-table th {
          padding: 16px 20px;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: #64748b;
          background: #f8fafc;
          border-bottom: 1px solid #e2e8f0;
        }

        .results-table td {
          padding: 16px 20px;
          font-size: 14px;
          border-bottom: 1px solid #e2e8f0;
          vertical-align: middle;
        }

        .results-table tbody tr:last-child td {
          border-bottom: none;
        }

        .results-table tbody tr:hover {
          background: #f8fafc;
        }

        .roll-col {
          font-weight: 600;
          color: #64748b;
          width: 80px;
        }

        .name-col {
          font-weight: 600;
          color: #0f172a;
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: #e2e8f0;
          color: #475569;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          font-weight: 700;
        }

        .marks-col {
          font-weight: 600;
          color: #0f172a;
        }
        
        .marks-col span {
          font-weight: 400;
          color: #64748b;
          font-size: 12px;
        }

        /* Grade Badges */
        .grade-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 4px 12px;
          border-radius: 8px;
          font-size: 12px;
          font-weight: 700;
          min-width: 40px;
        }

        .grade-badge.grade-a { background: #dcfce7; color: #166534; }
        .grade-badge.grade-b { background: #e0f2fe; color: #0369a1; }
        .grade-badge.grade-c { background: #fef9c3; color: #854d0e; }
        .grade-badge.grade-d { background: #fee2e2; color: #991b1b; }

        /* Action Button */
        .btn-view {
          background: transparent;
          border: 1px solid #e2e8f0;
          color: #64748b;
          padding: 6px 12px;
          border-radius: 8px;
          font-family: inherit;
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 6px;
          transition: all 0.2s ease;
        }

        .btn-view:hover {
          background: #18181b;
          color: #fff;
          border-color: #18181b;
        }

        .no-data {
          text-align: center;
          padding: 40px !important;
          color: #64748b;
          font-style: italic;
        }

        /* ---------- RESPONSIVE ---------- */
        @media (max-width: 768px) {
          .results-header {
            flex-direction: column;
            align-items: flex-start;
          }
          
          .header-actions {
            width: 100%;
            justify-content: space-between;
          }
          
          .table-controls {
            flex-direction: column;
            align-items: stretch;
          }

          .search-box {
            max-width: 100%;
          }

          .filters-group {
            justify-content: space-between;
          }
          
          .results-table th, 
          .results-table td {
            padding: 12px 15px;
          }
        }
      `}</style>

      <div className="results-page">
        <div className="results-container">
          
          {/* HEADER SECTION */}
          <div className="results-header">
            <div>
              <h1>Examination Results</h1>
              <p>View and analyze student performance across subjects</p>
            </div>
            <div className="header-actions">
              <button className="btn-primary">
                <i className="fa fa-download"></i> Export Report
              </button>
            </div>
          </div>

          {/* STATS CARDS */}
          <div className="stats-grid">
            <div className="stat-card total">
              <div className="stat-icon"><i className="fa fa-file-text-o"></i></div>
              <div className="stat-info">
                <span>Total Records</span>
                <strong>{totalRecords}</strong>
              </div>
            </div>
            <div className="stat-card average">
              <div className="stat-icon"><i className="fa fa-bar-chart"></i></div>
              <div className="stat-info">
                <span>Average Marks</span>
                <strong>{averageMarks}</strong>
              </div>
            </div>
            <div className="stat-card highest">
              <div className="stat-icon"><i className="fa fa-trophy"></i></div>
              <div className="stat-info">
                <span>Highest Marks</span>
                <strong>{highestMarks}</strong>
              </div>
            </div>
            <div className="stat-card pass">
              <div className="stat-icon"><i className="fa fa-check-circle"></i></div>
              <div className="stat-info">
                <span>Pass Rate</span>
                <strong>{passPercentage}%</strong>
              </div>
            </div>
          </div>

          {/* FILTER & SEARCH BAR */}
          <div className="table-controls">
            <div className="search-box">
              <i className="fa fa-search"></i>
              <input 
                type="text" 
                placeholder="Search by name or roll no..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            
            <div className="filters-group">
              <div className="filter-box">
                <label>Class:</label>
                <select value={filterClass} onChange={(e) => setFilterClass(e.target.value)}>
                  <option value="All">All</option>
                  <option value="10-A">10-A</option>
                  <option value="10-B">10-B</option>
                  <option value="10-C">10-C</option>
                </select>
              </div>

              <div className="filter-box">
                <label>Subject:</label>
                <select value={filterSubject} onChange={(e) => setFilterSubject(e.target.value)}>
                  <option value="All">All</option>
                  <option value="Mathematics">Mathematics</option>
                  <option value="Science">Science</option>
                  <option value="English">English</option>
                </select>
              </div>
            </div>
          </div>

          {/* DATA TABLE */}
          <div className="table-responsive">
            <table className="results-table">
              <thead>
                <tr>
                  <th>Roll No</th>
                  <th>Student Name</th>
                  <th>Class</th>
                  <th>Subject</th>
                  <th>Marks</th>
                  <th>Grade</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((student) => (
                    <tr key={student.id}>
                      <td className="roll-col">{student.roll}</td>
                      <td className="name-col">
                        <div className="avatar">{student.name.charAt(0)}</div>
                        {student.name}
                      </td>
                      <td>{student.class}</td>
                      <td>{student.subject}</td>
                      <td className="marks-col">
                        {student.marksObtained} <span>/ {student.totalMarks}</span>
                      </td>
                      <td>
                        <span className={`grade-badge ${getGradeColor(student.grade)}`}>
                          {student.grade}
                        </span>
                      </td>
                      <td>
                        <button className="btn-view" title="View Details">
                          <i className="fa fa-eye"></i> View
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="no-data">No results found matching your criteria.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </>
  );
};

export default Results;